export default "__VITE_ASSET__CoNnGeX9__"